import { useEffect } from 'react';

/**
 * Useful for needing to scroll when there isn't a route change
 * which would be handled by useScrollOnNavigation
 */
export const useScrollOnMount = (position = 0) => {
  useEffect(() => {
    document.documentElement.scrollTo({ top: position });
    // We only want to run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
